'use client';

import { useEffect } from 'react';
import type { ElasticVehicle } from '@//app/api/search/vehicles/[id]';
import { useLegacyTrackPageView } from '@//data/tracking/useLegacyTrackPageView';
import { useLegacyTrackView } from '@//data/tracking/useLegacyTrackView';

interface VehicleViewTrackerProps {
  vehicle: ElasticVehicle;
}

const VehicleViewTracker = ({ vehicle }: VehicleViewTrackerProps) => {
  const { trackLegacyView } = useLegacyTrackView();
  const { trackLegacyPageView } = useLegacyTrackPageView();

  useEffect(() => {
    trackLegacyView(vehicle);
    trackLegacyPageView(vehicle);
  }, []);

  return null;
};

export default VehicleViewTracker;
